import React from 'react';
import { translate } from '@utils/i18n';
import './OptimizationToggleStyles.scss';
const namespace = 'features.settings.calendar_settings';
function OptimizationToggle({ enabled, isUpdating, onToggle }) {
    return (React.createElement("section", { className: "calendar-settings-toggle" },
        React.createElement("fieldset", { className: "form__set--vertical--space" },
            React.createElement("div", { className: "form__field--x-full", style: { width: '411px' } },
                React.createElement("span", { className: "qmb-toggle-switch--check" },
                    React.createElement("input", { id: "calendar-optimization-enable", type: "checkbox", className: "qmb-checkbox", checked: enabled, disabled: isUpdating, onChange: onToggle }),
                    React.createElement("label", { htmlFor: "calendar-optimization-enable" }, "\u00A0"),
                    React.createElement("label", { htmlFor: "calendar-optimization-enable", className: "qmb-label" }, translate('optimization_toggle_label', { namespace })))))));
}
export default OptimizationToggle;
